import React from 'react';
import { ElevatedButton } from '@producer/ui-kit';

import styles from './empty-table-placeholder.module.scss';
type EmptyTablePlaceholderProps = {
  description: string;
  action?: {
    text: string;
    onClick?: React.ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  };
};

export const EmptyTablePlaceholder: React.FC<EmptyTablePlaceholderProps> = ({
  description,
  action,
}) => {
  const { text, onClick = () => {} } = action || {};

  return (
    <div className={styles['container']}>
      <p className={styles['description']}>{description}</p>

      {action && (
        <div className={styles['action-container']}>
          <ElevatedButton onClick={onClick} text={text!} isFullWidth />
        </div>
      )}
    </div>
  );
};
